import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-default-availability',
  templateUrl: './default-availability.component.html',
  styleUrls: ['./default-availability.component.scss']
})
export class DefaultAvailabilityComponent implements OnInit {

  @Input() scope;
  constructor() { }

  ngOnInit(): void {
  }

}
